const getCampaignSourceFromUrl = () => {
  const url = new URL(window.location.href);
  const gclid = url.searchParams.get('gclid');

  if (gclid) {
    return 'Google Ads';
  }

  const utmSource = url.searchParams.get('utm_source');

  if (utmSource) {
    return utmSource;
  }

  return null;
};

export const handleCampaignSessionStorage = () => {
  const subjectSuffixElements = document.querySelectorAll('[name=subject-suffix]');
  const maybeSessionStorageCampaingSource = sessionStorage.getItem('campaign_source');

  if (maybeSessionStorageCampaingSource) {
    subjectSuffixElements.forEach((el) => {
      el.value = `Campaign Source:${maybeSessionStorageCampaingSource}`;
    });
  } else {
    const campaignSourceFromUrl = getCampaignSourceFromUrl();

    if (campaignSourceFromUrl !== null) {
      sessionStorage.setItem('campaign_source', campaignSourceFromUrl);
      subjectSuffixElements.forEach((el) => {
        el.value = `Campaign Source:${campaignSourceFromUrl}`;
      });
    }
  }
};

export const throttle = (fn, wait) => {
  let time = Date.now();

  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};
